import { Component } from 'react';
import { Image, Text, View } from 'react-native';

import { translate } from '../../../i18n';
import {
  CVSDeliveryDataFromSelector,
  HomeDeliveryDataFromSelector,
} from '../../../types/DeliveryData';
import type { DeliveryData } from '../../../types/TransactionDetail';
import styles from './styles';

export interface Props {
  deliveryData:
    | CVSDeliveryDataFromSelector // data from getDeliveryData()
    | HomeDeliveryDataFromSelector // data from getDeliveryData()
    | DeliveryData; // data from getTransaction(id: string)
  testID?: string;
}
export default class DeliverAddressCard extends Component<Props> {
  renderAddressDetail = () => {
    const { deliveryData } = this.props;

    if ('store' in deliveryData) {
      return (
        <>
          <Text style={[styles.addressDetailText, styles.fontWeightBold]}>
            {deliveryData.address_label}
          </Text>
          <Text style={styles.addressDetailText}>{deliveryData.address}</Text>
        </>
      );
    } else if ('city' in deliveryData) {
      return (
        <Text style={styles.addressDetailText}>
          {[
            deliveryData.zip_code,
            deliveryData.city,
            deliveryData.district,
            deliveryData.address,
            deliveryData.address2,
          ].join(' ')}
        </Text>
      );
    } else {
      return (
        <Text style={styles.addressDetailText}>
          {[deliveryData.zip_code, deliveryData.address].join(' ')}
        </Text>
      );
    }
  };

  render() {
    const { deliveryData } = this.props;

    return (
      <View style={styles.homeDeliverCard}>
        <View style={styles.addressSection}>
          <View style={styles.recipientTitleField}>
            <Text style={styles.recipientTitleText}>
              {translate('receiver')}
            </Text>
          </View>

          <View style={styles.recipientAndPhoneSection}>
            <View style={styles.recipientField}>
              <Text style={styles.recipientText} numberOfLines={1}>
                {deliveryData.name}
              </Text>
            </View>

            <View style={styles.phoneField}>
              <Text style={styles.phoneText}>
                {'area_phone_code' in deliveryData
                  ? deliveryData.area_phone_code
                  : ''}
                {'tel' in deliveryData
                  ? deliveryData.tel
                  : deliveryData.area_phone}
              </Text>
            </View>
          </View>

          <View style={styles.addressDetailSection}>
            <View style={styles.addressTitleField}>
              <Text style={styles.addressTitleText}>
                {'store' in deliveryData
                  ? translate('convenienceStoreName')
                  : translate('recipientAddress')}
              </Text>
            </View>
            <View style={styles.addressDetailFiled}>
              {this.renderAddressDetail()}
            </View>
          </View>

          <Image
            key="mail_pattern"
            style={styles.mailPatternField}
            resizeMode="repeat"
            source={require('./assets/img_ptrn_add.png')}
          />
        </View>

        {'store' in deliveryData && (
          <View style={styles.cvsPickUpGoodsHintField}>
            <Text style={styles.cvsPickUpGoodsHintText}>
              {translate('cvs-pick-up-goods-hint')}
            </Text>
          </View>
        )}
      </View>
    );
  }
}
